import React from 'react'
import "../CSS/style.css"
// import { Link } from 'react-router-dom'
export default function Notification() {
  return (
    <>
    <marquee className="notification" behavior="sliding">UnlockCode - Mobile App Launching Soon . . . . . . </marquee>
    </>
  )
}
